<div fxLayout="row" fxFlexAlign="center">
  <mat-spinner id="spinner"></mat-spinner>
</div>
<div fxLayout="row" fxFlexAlign="center">
  <h1 i18n="@@loading-label" id="loading-label">Loading...</h1>
</div>
